module.exports = __webpack_public_path__ + "static/img/toplogo.28850c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/imgs/toplogo.png
// module id = W3ZB
// module chunks = 1